import { Component, OnInit } from '@angular/core';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
@UntilDestroy()
@Component({
  selector: 'literax-buttons-bar-layout',
  templateUrl: './buttons-bar-layout.component.html',
  styleUrls: ['./buttons-bar-layout.component.scss']
})
export class ButtonsBarLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
